/**
 * Hook personalizado para detectar se o usuário está em um dispositivo móvel
 * Retorna true se for mobile, false caso contrário
 * 
 * Versão TypeScript otimizada para Next.js
 */

import { useEffect,useState } from 'react';

const useMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Função para verificar se é mobile
    const checkIfMobile = (): void => {
      // Verifica se window está disponível (importante para SSR no Next.js)
      if (typeof window !== 'undefined') {
        const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
        
        // Regex para detectar dispositivos móveis
        const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        
        // Verifica também a largura da tela para maior confiabilidade
        const hasSmallScreen = window.innerWidth < 768;
        
        setIsMobile(isMobileDevice || hasSmallScreen);
      }
    };

    // Verifica imediatamente ao montar o componente
    checkIfMobile();

    // Adiciona listener para redimensionamento da tela
    window.addEventListener('resize', checkIfMobile);

    // Remove listener ao desmontar
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return isMobile;
};

export default useMobile;